'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRouter = require('react-router');

var _reactBootstrap = require('react-bootstrap');

var _reactRedux = require('react-redux');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _filter = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter);

var _CardSliderMobile = require('./CardSliderMobile');

var _CardSliderMobile2 = _interopRequireDefault(_CardSliderMobile);

var _reactGa = require('react-ga');

var _reactGa2 = _interopRequireDefault(_reactGa);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var GeneralViewMobile = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    shops: state.shops.generalView,
    generalViewLoading: state.shops.generalViewLoading,
    generalViewLoaded: state.shops.generalViewLoaded
  };
}, (0, _extends3.default)({}, shopActions, filterActions)), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(GeneralViewMobile, _Component);

  function GeneralViewMobile() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, GeneralViewMobile);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = GeneralViewMobile.__proto__ || (0, _getPrototypeOf2.default)(GeneralViewMobile)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      pageSize: 18,
      firstLoad: false,
      category: []
    }, _this.handleChangeDiscoverNearby = function (category, seeMore) {
      var linkSeeMore = '/kham-pha';
      if (category.length > 0) {
        linkSeeMore += '?category=' + category.join(',');
      }
      _reactRouter.browserHistory.push(linkSeeMore);
      if (seeMore === true) {
        _reactGa2.default.event({
          category: 'Shop',
          action: 'Clicked See More',
          label: 'Prominent'
        });
      } else {
        _reactGa2.default.event({
          category: 'Shop',
          action: 'Clicked Title',
          label: 'Prominent'
        });
      }
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(GeneralViewMobile, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.generalViewLoaded && this.props.generalViewLoading !== true || !this.props.shops || !this.state.firstLoad) {
        this.getResult.call(this, this.props.id);
      }
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.generalViewLoading) {
        this.setState({ firstLoad: true });
      }
      if (this.props.id !== nextProps.id) {
        this.getResult.call(this, nextProps.id);
      }
    }
  }, {
    key: 'getResult',
    value: function getResult(id) {
      var filter = {
        pageSize: this.state.pageSize,
        category: this.props.category.join(','),
        province: this.props.province
      };
      this.props.getGeneralView(filter, id);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          shops = _props.shops,
          mainCat = _props.mainCat;
      var pageSize = this.state.pageSize;

      var styles = require('./GeneralViewMobile.scss');
      var cards = [];
      if (shops && shops.length > 0) {
        var length = shops.length > pageSize ? pageSize : shops.length;
        for (var index = 0; index < length; index++) {
          cards.push(_react2.default.createElement(_CardSliderMobile2.default, { shop: shops[index], key: index }));
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.nearMeMobile },
        _react2.default.createElement(
          'div',
          { className: styles.headerBox },
          _react2.default.createElement(
            'div',
            { className: styles.header },
            _react2.default.createElement(
              'div',
              { className: styles.left },
              _react2.default.createElement(
                'div',
                {
                  className: styles.title,
                  onClick: function onClick() {
                    return _this2.handleChangeDiscoverNearby(mainCat);
                  }
                },
                '\u0110\u1ECBa \u0111i\u1EC3m xem chung'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: styles.right },
              _react2.default.createElement(
                'div',
                {
                  className: styles.seeMore,
                  onClick: function onClick() {
                    return _this2.handleChangeDiscoverNearby(mainCat, true);
                  }
                },
                'Xem th\xEAm',
                _react2.default.createElement(_reactBootstrap.Glyphicon, (0, _defineProperty3.default)({
                  className: styles.arrowRight,
                  glyph: 'menu-right'
                }, 'className', styles.arrowRight))
              )
            )
          )
        ),
        _react2.default.createElement(
          'div',
          { className: styles.sliderNearMeWrapper },
          _react2.default.createElement(
            'div',
            { className: styles.sliderNearMe },
            cards
          )
        )
      );
    }
  }]);
  return GeneralViewMobile;
}(_react.Component), _class2.propTypes = {
  shops: _react.PropTypes.array,
  getGeneralView: _react.PropTypes.func.isRequired,
  province: _react.PropTypes.string,
  generalViewLoaded: _react.PropTypes.bool,
  generalViewLoading: _react.PropTypes.bool,
  changeSortType: _react.PropTypes.func,
  category: _react.PropTypes.array,
  mainCat: _react.PropTypes.array,
  id: _react.PropTypes.string
}, _temp2)) || _class);
exports.default = GeneralViewMobile;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Detail/GeneralViewMobile.js
// module id = 1589
// module chunks = 0